module.exports = __webpack_public_path__ + "img/insist.93a3cfd6.png";